<template>
  <div class="new-meeting-page">
    <div class="app-block">
      <div class="app-block-title">
        <FeatherIcon type="plus-circle" size="24"></FeatherIcon>
        <h1>Nouvelle Réunion</h1>
      </div>

      <form @submit.prevent="createMeeting">
        <div class="form-group">
          <label for="title"
            >Titre de la réunion <span class="required">*</span></label
          >
          <input type="text" id="title" v-model="meeting.title" required />
        </div>

        <div class="form-group">
          <label for="date">Date <span class="required">*</span></label>
          <input
            type="date"
            id="date"
            v-model="meeting.meeting_date"
            required
          />
        </div>

        <div class="form-group">
          <label for="time">Heure</label>
          <input type="time" id="time" v-model="meeting.meeting_time" />
        </div>

        <div class="form-group">
          <label for="notes">Notes</label>
          <textarea id="notes" v-model="meeting.notes"></textarea>
        </div>

        <div class="form-actions">
          <BaseButton type="submit" variant="primary" :disabled="loading">
            <FeatherIcon
              v-if="loading"
              type="loader"
              size="18"
              animation="spin"
            ></FeatherIcon>
            <FeatherIcon v-else type="check" size="18"></FeatherIcon>
            Créer la réunion
          </BaseButton>
          <BaseButton type="button" variant="secondary" @click="cancel">
            Annuler
          </BaseButton>
        </div>
        <p v-if="error" class="error-message">{{ error }}</p>
      </form>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseButton.vue";
import FeatherIcon from "vue-feather";
import apiService from "@/services/apiService";

export default {
  name: "NewMeetingView",
  components: {
    BaseButton,
    FeatherIcon,
  },
  data() {
    return {
      meeting: {
        // Structure pour le nouveau meeting
        title: "",
        meeting_date: "",
        meeting_time: null, // Utiliser null pour l'heure optionnelle
        notes: null,
      },
      loading: false,
      error: null,
    };
  },
  methods: {
    async createMeeting() {
      if (!this.meeting.title || !this.meeting.meeting_date) {
        this.error = "Veuillez remplir les champs requis.";
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        // Nettoyer les champs vides avant d'envoyer
        const meetingDataToSend = { ...this.meeting };
        if (meetingDataToSend.meeting_time === "")
          meetingDataToSend.meeting_time = null;
        if (meetingDataToSend.notes === "") meetingDataToSend.notes = null;

        const newMeeting = await apiService.createMeeting(meetingDataToSend);
        console.log("Meeting created:", newMeeting);
        // Naviguer vers la page de détail de la nouvelle réunion ou la liste
        this.$router.push({
          name: "MeetingDetail",
          params: { id: newMeeting.id },
        });
      } catch (e) {
        this.error = "Erreur lors de la création de la réunion: " + e.message;
        console.error("Create meeting failed:", e);
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$router.push("/"); // Retour à la liste
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/_variables.scss";

.new-meeting-page {
  max-width: 600px; // Formulaire un peu moins large que la liste/détail
  margin: $space-xl auto;
  padding: 0 $space-md;

  .app-block {
    padding: $space-xl; // Plus de padding pour le formulaire
  }

  form {
    display: grid;
    gap: $space-md; // Espacement entre les groupes de formulaire
  }

  .form-group {
    label {
      display: block; // Chaque label sur une nouvelle ligne
      margin-bottom: $space-xs;
      font-weight: bold;
      color: $color-text-900;
      font-size: $font-size-base;

      .required {
        color: $color-error; // Marqueur requis en rouge
        margin-left: $space-xs / 2;
      }
    }

    input[type="text"],
    input[type="date"],
    input[type="time"],
    textarea {
      width: 100%;
      padding: $space-sm;
      border: 1px solid $color-primary-100;
      border-radius: $border-radius-sm;
      font-size: $font-size-base;
      font-family: $font-body;
      color: $color-text-600;
      background-color: $color-background; // Fond léger pour les inputs
      transition: border-color $transition-duration-short ease-in-out,
        box-shadow $transition-duration-short ease-in-out;

      &:focus {
        outline: none;
        border-color: $color-primary-500;
        box-shadow: 0 0 0 3px rgba($color-primary-500, 0.2); // Ombre bleue légère au focus
      }
    }

    textarea {
      min-height: 150px; // Hauteur minimale pour la zone de texte
      resize: vertical; // Permet uniquement le redimensionnement vertical
    }
  }

  .form-actions {
    display: flex;
    gap: $space-md; // Espace entre les boutons
    margin-top: $space-lg;
    justify-content: flex-end; // Aligner les boutons à droite

    .base-button {
      // Styles spécifiques aux boutons dans les formulaires si besoin
    }
  }

  .error-message {
    color: $color-error;
    text-align: center;
    margin-top: $space-md;
  }
}
</style>
